import { connect } from 'react-redux';
import Flag from './Flag';

const mapState = state => ({
  flags: state.flags,
});

export default connect(mapState)(Flag);
